export enum ProjectLinkType {
  SelfSource          = 1,
  CustomSearch        = 2,
  ConsultantReferral  = 3,
}